import store from "@/store"
import router from "../router/index"
import { IWindowOptions } from "@/types/base/IWindowOptions"
import { EventType } from "../types/base/IWindowOptions"
import jwt_decode from "jwt-decode"
import { IOrderStatusForRequestOrderList } from "@/types/interface/IOrderDto"
import { OrderStatus } from "@/types/enum/OrderEnum"

export const event = (event: string, data: any, callback?: Function) => {
  if (window.bmnative) {
    sendEvent(event, data)
  } else {
    callback ? callback() : ""
  }
}

export const toLocalTime = (utcTimeString: string | Date): string => {
  const dt = new Date(utcTimeString)
  const day = dt.getDate(),
    month = dt.getMonth() + 1,
    year = dt.getFullYear(),
    hours = dt.getHours(),
    minutes = dt.getMinutes()

  return `${pad(month)}/${pad(day)}/${year} ${pad(hours)}:${pad(minutes)}`
}

const pad = (number: number) => {
  if (number < 10) return `0${number}`
  return number
}

export const formatterDate = (date: string | Date): string => {
  const dt = new Date(date)
  const day = dt.getDate()
  const month = dt.getMonth() + 1
  const year = dt.getFullYear()
  return `${year}-${pad(month)}-${pad(day)}`
}

export const handleRefreshTokenEvent = () => {
  switch (store.state.options.oauthType) {
    case "google":
      event(
        "refreshToken",
        JSON.stringify({
          refreshToken: store.state.options.refreshToken,
          alias: store.getters.makeAlias,
          type: store.state.options.oauthType === "google" ? "Google" : "MSAL",
        })
      )
      break
    case "microsoft":
      store.commit("handleOptions", {
        token: "",
        refreshToken: "",
        eventType: "",
        oauthType: "",
      })
      event("signout", store.getters.makeAlias)
      router.replace({ name: "Login" })
      break
  }
}

interface osType {
  isTablet: boolean
  isPhone: boolean
  isAndroid: boolean
  isPc: boolean
}
export const os = (): osType => {
  let ua = navigator.userAgent,
    isAndroid = /(?:Android)/.test(ua),
    isFireFox = /(?:Firefox)/.test(ua),
    isChrome = /(?:Chrome|CriOS)/.test(ua),
    isTablet =
      /(?:iPad|PlayBook)/.test(ua) ||
      (isAndroid && !/(?:Mobile)/.test(ua)) ||
      (isFireFox && /(?:Tablet)/.test(ua)),
    isPhone = /(?:iPhone)/.test(ua) && !isTablet,
    isPc = !isPhone && !isAndroid && !isTablet
  return {
    isTablet,
    isPhone,
    isAndroid,
    isPc,
  }
}

export const parseQueryToObject = () => {
  let search = window.location.search
  try {
    let splitArr = search.substring(1).split("&")
    return splitArr.reduce((obj: any, item: string) => {
      let arr = item.split("=")
      return Object.assign(obj, {
        [arr[0]]: decodeURIComponent(arr[1].replace(/\//g, "")),
      })
    }, {})
  } catch (error) {
    return {}
  }
}

export const sendEvent = (event: string, data: any) => {
  if (window.bmnative && window.bmnative.fireEvent) {
    window.bmnative.fireEvent(event, data)
  } else if (window.webkit) {
    window.webkit.messageHandlers.fireEvent.postMessage({
      event,
      data,
    })
  }
}

export const getMicrosoftIdToken = () => {
  let urlString = window.location.href
  if (urlString.includes("id_token")) {
    let idTokenIndex = urlString.indexOf("id_token=")
    let lastString = urlString.substring(idTokenIndex)
    lastString = lastString
      .replace("id_token=", "")
      .replace("&state=12345", "")
      .split("&session_state=")[0]

    if (store.state.options.token !== lastString) {
      let options: IWindowOptions = {
        token: lastString,
        refreshToken: "",
        eventType: EventType.Init,
        oauthType: "microsoft",
        id: Math.random()
          .toString(32)
          .substring(2),
        meta: {
          imageSrc: "",
        },
      }
      store.commit("handleOpenInBrowser", true)
      sessionStorage.setItem("openInBrowser", "true")
      store.commit("handleOptions", options)
    }
    // commitTokenExpireTimeToVuex(lastString);
    return lastString
  } else {
    return false
  }
}

export const commitTokenExpireTimeToVuex = (token: string) => {
  const decode = jwt_decode(token)
  const { exp } = decode
  store.commit("handleTokenExpireTime", exp * 1000)
}

export const cleanStatusAndTimerForLogout = () => {
  store.commit("handleClearIntervals", "")
  store.commit("handleOptions", {
    token: "",
    refreshToken: "",
    eventType: "",
    oauthType: "",
    id: "",
    meta: {},
  })
  store.commit("handleLoginMerchant", {
    autoAcceptOrder: false,
    logo: "",
    status: 0,
    merchAddress: "",
    merchName: "",
    merchId: "",
    userId: "",
    userName: "",
  })
  store.commit("handleOrderList", [])
  store.commit("handleUserLoginMerchants", [])
  store.commit("handleUserInfo", {
    userId: "",
    userName: "",
  })
  store.commit("handleTokenExpireTime", 0)
  store.commit("handleMerchId", "")
  // store.commit("handleTabIndex", 0) // 会触发order接口
  store.dispatch("cancelTimer")
  store.commit("handleClearIntervals", "")
  store.commit("handleKeyword", "")
  store.commit("handleCurrentOrderPage", 1)
  store.commit("handleExactSearch", true)
  store.commit("handleIsInPreOrderTab", false)
  store.commit("handlePreOrderDate", "")
  store.commit("handleupdateOrderListInSignalR", 0)
  store.commit("handleupdateOrderListInSignalRMessageCount", 0)
  store.commit("handleOrderCacheMinutes", 0)
  store.commit("handleRequestTimeStamp", 0)
  store.commit("handleImRequestTimeStamp", 0)
  store.commit("handleMerchIds", "")
  store.commit("handleOrderTotal", 0)
  store.commit("handleCurrentOrderTab", "Processing")
  store.commit("handleCurrentMessagePage", 1)
  store.commit("handlePreOrderCountForDate", [])
  store.commit("handleIsAsapOnly", false)
  store.commit("handleMerchDecideConfirmedTime", false)
  store.commit("handleIsPrintEnable", false)
  store.commit("handleSignalRConnectionChanged", false)
  store.commit("handleSignalRInitializingStatus", false)
  clearInterval(window.wsConnectionTimer)
  clearInterval(window.pollingTimer)
  sessionStorage.removeItem("merchId")
  sessionStorage.removeItem("loginMerchant")
  sessionStorage.removeItem("oauthType")
  sessionStorage.removeItem("token")
  sessionStorage.removeItem("isLogin")
  window.wsConnectionTimer = null
  window.pollingTimer = null
  event("signout", "")
  window.Vue.$router.replace({ name: "Login" })
}

export const getOrderStatusForRequestOrderList = (
  orderProcess: keyof IOrderStatusForRequestOrderList
): OrderStatus[] => {
  switch (orderProcess) {
    case "Processing":
      return [
        OrderStatus.WaitingForAcceptance,
        OrderStatus.Processing,
        OrderStatus.Ready,
        OrderStatus.Delivering,
      ]
    case "PreOrder":
      return [OrderStatus.Processing, OrderStatus.Ready, OrderStatus.Delivering]
    case "Incoming":
      return [OrderStatus.WaitingForAcceptance]
    case "Preparing":
      return [OrderStatus.Processing]
    case "Ready":
      return [OrderStatus.Ready]
    case "Delivering":
      return [OrderStatus.Delivering]
    case "Completed":
      return [
        OrderStatus.Completed,
        OrderStatus.CancelRejected,
        OrderStatus.Cancelled,
      ]

    case "Refunding":
      return [
        OrderStatus.Refunding,
        OrderStatus.Refunded,
        OrderStatus.CancelRequested,
      ]
    case "Rejected":
      return [OrderStatus.Rejected]
    default:
      return []
  }
}
